import eventBus from './eventBus';
import isInViewport from './isInViewport';

const animateOnScroll = (element, callback, offset) => {
    const maybeRunAnimation = () => {
        if (!isInViewport(element, offset)) return;
        window.removeEventListener('scroll', maybeRunAnimation);
        window.removeEventListener('resize', maybeRunAnimation);
        window.removeEventListener('load', maybeRunAnimation);
        callback();
    };
    window.addEventListener('scroll', maybeRunAnimation);
    window.addEventListener('resize', maybeRunAnimation);
    window.addEventListener('load', maybeRunAnimation);
};

export default animateOnScroll;
